import React, { useState } from 'react'
import {
  BaseIcon,
  CustomButton,
  FormDropDown,
  FormInput,
  FormInputRupiah,
  ModalContainer,
  ModalForm
} from 'components'
import { Form, Formik } from 'formik'
import { mdiClose } from '@mdi/js'
import { ModalPilihUnitCYOC, PhotoSparepartCard } from '..'
import { IcClose } from 'assets/icons'

const ModalCreateUpdateSparepartCYOC = ({ state, dropDownKategori, onClose, onSubmit }) => {
  const [harga, setHarga] = useState(state.type === 'create' ? '' : state.harga)
  const [photoSparepart, setPhotoSparepart] = useState()
  const [isModalPilihUnit, setIsModalPilihUnit] = useState({
    show: false
  })
  const [units, setUnits] = useState([
    { title: 'Honda Civic Nouva', isSelected: false },
    { title: 'Toyota Kijang', isSelected: false },
    { title: 'Honda Civic', isSelected: false },
    { title: 'Toyota Kijang Innova', isSelected: false },
    { title: 'Honda HRV', isSelected: false },
    { title: 'Honda BRV', isSelected: false }
  ])

  const onReturnItemUnitSelected = (title, index) => (
    <div className="flex flex-row items-center justify-center space-x-2 w-full py-1 px-2 rounded-xl bg-primary-50">
      <span className="font-medium text-xs text-primary-700">{title}</span>
      <div
        onClick={() => {
          const tempArr = [...units]
          const itemSelected = tempArr.find((item, indexPr) => indexPr === index)
          itemSelected.isSelected = false
          setUnits(tempArr)
        }}
        className="flex items-center justify-center hover:cursor-pointer">
        <IcClose className="text-primary-500" size={14} />
      </div>
    </div>
  )

  return (
    <ModalContainer>
      <ModalForm minWidth="min-w-[26%]" maxWidth="max-w-[26%]" zIndex="z-20">
        {isModalPilihUnit.show ? (
          <ModalPilihUnitCYOC
            data={units}
            onClose={() => setIsModalPilihUnit({ show: false })}
            onSelected={(index) => {
              const tempArr = [...units]
              const itemSelected = tempArr.find((item, indexPr) => indexPr === index)
              itemSelected.isSelected = !itemSelected.isSelected
              setUnits(tempArr)
            }}
          />
        ) : null}
        <div className="flex flex-col w-full space-y-5">
          <div className="flex flex-row items-center justify-between">
            <span className="font-semibold text-gray-900 text-lg">
              {`${state.type === 'create' ? 'Tambah' : 'Edit'} Sparepart`}
            </span>
            <div
              className="flex h-8 w-8 items-center justify-center hover:cursor-pointer"
              onClick={() => onClose()}>
              <BaseIcon path={mdiClose} iconSize={21} color="#98A2B3" />
            </div>
          </div>
          <PhotoSparepartCard
            photo={photoSparepart}
            onChangePhoto={(value) => setPhotoSparepart(value)}
          />
          <Formik
            initialValues={{
              namaSparepart: state.type === 'create' ? '' : state.namaSparepart,
              kategoriSelector: state.type === 'create' ? '' : state.kategori,
              deskripsi: '',
              harga
            }}>
            <Form key="createUpdateSparepartCYOCForm">
              <div className="flex flex-col w-full space-y-5">
                <FormInput
                  label="Nama Sparepart"
                  name="namaSparepart"
                  placeholder="Masukkan Nama Sparepart"
                  onValidate={(value) => {}}
                />
                <FormDropDown
                  label="kategori"
                  name="kategoriSelector"
                  data={dropDownKategori}
                  onChange={(value) => {}}
                />
                <FormInput
                  label="Deskripsi"
                  name="deskripsi"
                  placeholder="Masukkkan Deskripsi"
                  height="85px"
                  component="textarea"
                  onBlur={() => {}}
                  onValidate={(value) => {}}
                />
                <div className="flex flex-col space-y-2">
                  <span className="font-medium text-gray-700">Unit</span>
                  {units.filter((item) => item.isSelected === true).length > 0 ? (
                    <div className="grid grid-cols-3 gap-2 w-full items-center">
                      {units
                        .filter((itemFr) => itemFr.isSelected === true)
                        .slice(
                          0,
                          units.filter((item) => item.isSelected === true).length < 5
                            ? units.filter((item) => item.isSelected === true).length
                            : 4
                        )
                        .map((itemCh, indexCh) => onReturnItemUnitSelected(itemCh.title, indexCh))}
                      {units.filter((item) => item.isSelected === true).length > 4 ? (
                        <div
                          onClick={() => setIsModalPilihUnit({ show: true })}
                          className="flex hover:cursor-pointer">
                          <span className="font-medium text-primary-600">{`${
                            units.filter((item) => item.isSelected === true).length - 4
                          }+ Unit Lainnya`}</span>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div className="max-w-xs">
                    <CustomButton type="plain" onClick={() => setIsModalPilihUnit({ show: true })}>
                      Pilih Unit
                    </CustomButton>
                  </div>
                </div>
                <FormInputRupiah
                  label="Harga"
                  name="harga"
                  value={harga}
                  mode="normal"
                  isWithLabelRp
                  onChange={(value) => setHarga(value)}
                />
                <div className="flex flex-row w-full items-center justify-end space-x-4">
                  <CustomButton type="plain" onClick={() => onClose()}>
                    Cancel
                  </CustomButton>
                  <CustomButton onClick={() => onSubmit()}>
                    {state.type === 'create' ? 'Tambah Sparepart' : 'Simpan'}
                  </CustomButton>
                </div>
              </div>
            </Form>
          </Formik>
        </div>
      </ModalForm>
    </ModalContainer>
  )
}

export default ModalCreateUpdateSparepartCYOC
